// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockAlarm_wrapper__2lrFL"};